import { render, staticRenderFns } from "./CartContent.vue?vue&type=template&id=9c65aab4&scoped=true&"
import script from "./CartContent.vue?vue&type=script&lang=js&"
export * from "./CartContent.vue?vue&type=script&lang=js&"
import style0 from "./CartContent.vue?vue&type=style&index=0&id=9c65aab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c65aab4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VSheet})
